<mat-dialog-content>
  <div class="row">
      <div *ngIf="data?.showIcon" class="swal2-icon swal2-question swal2-icon-show" style="display: flex;"><div class="swal2-icon-content">!</div></div>
      <h1 class="title" *ngIf="data?.title">{{ data?.title }}!</h1>
      <p *ngIf="data?.msg">{{ data?.msg }}</p>
   </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="cancel-button" mat-flat-button mat-dialog-close>{{ data?.noBtnName }}</button>
  <button mat-flat-button mat-dialog-close="true" color="primary" cdkFocusInitial>{{ data?.yesBtnName }}</button>
</mat-dialog-actions>